import { defineStore } from 'pinia'
import { ref } from 'vue'

import { configApi, type ModelCatalogConfig, type ModelCatalogItem } from '@/api/config'

const EMPTY_MODEL_CATALOG: ModelCatalogConfig = {
  text_models: [],
  image_models: [],
  video_models: [],
  compliance_models: [],
}

export const useModelCatalogStore = defineStore('modelCatalog', () => {
  const catalog = ref<ModelCatalogConfig>({ ...EMPTY_MODEL_CATALOG })
  const loading = ref(false)
  const loaded = ref(false)

  async function ensureLoaded(force = false) {
    if (loading.value) {
      return
    }
    if (loaded.value && !force) {
      return
    }

    loading.value = true
    try {
      catalog.value = await configApi.getModelOptions()
      loaded.value = true
    } finally {
      loading.value = false
    }
  }

  function textModelsForOperation(operation: string): ModelCatalogItem[] {
    return catalog.value.text_models.filter((item) => !item.operations?.length || item.operations.includes(operation))
  }

  function imageModels(): ModelCatalogItem[] {
    return catalog.value.image_models
  }

  function videoModels(): ModelCatalogItem[] {
    return catalog.value.video_models
  }

  function complianceModels(): ModelCatalogItem[] {
    return catalog.value.compliance_models
  }

  return {
    catalog,
    loading,
    loaded,
    ensureLoaded,
    textModelsForOperation,
    imageModels,
    videoModels,
    complianceModels,
  }
})